import { Record } from 'immutable';
import EmptyList from './EmptyList';

const QuestionRecord = Record({
  ugc_id: null,
  subject_id: null,
  ugctype: 'Question',
  ugc_archetype: 'Question',
  created_date: '',
  updated_date: '',
  published: null,
  assigned_to: null,
  assigned_by: null,
  assignment_created_date: null,
  assignment_updated_date: null,
  merchant_user_id: '',
  author: '',
  location: '',
  question: '',
  email: '',
  source: '',
  ip_address: '',
  device_id: '',
  question_type: '',
  question_category_type: '',
  locale: '',
  ugc_related_content: EmptyList,
});

export default class Question extends QuestionRecord {
  static createWithData(data) {
    return new Question({
      ...data,
    });
  }
  getAnswers() {
    return this.ugc_related_content.filter(
      ugc => ugc.ugc_archetype === 'Answer'
    );
  }

  getMedia() {
    return this.ugc_related_content
      .filter(ugc => ugc.ugctype === 'Image' || ugc.ugctype === 'Video')
      .filter(ugc => ugc.parent_ugc_id === this.ugc_id);
  }
}



// WEBPACK FOOTER //
// ./src/models/Question.js